import React from 'react';
import { formatCurrency } from '../../../../utils';
import { FINANCING_TYPE, LEGAL_STRUCTURE } from '@trnsact/trnsact-shared-types';
import _ from 'lodash';
const capitalize = (s: string) => {
  if (s) {
    if (s.length <= 4) return s.toUpperCase();
    return s
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  } else return s;
};

export const friendlyFactName = (fact: string): string => {
  return capitalize(fact);
};

const formatValue = (type: string, value: any): string => {
  try {
    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }

    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }

    if (typeof value === 'number') {
      if (value === 0) {
        return '0';
      }
      return value.toString();
    }

    if (type === 'DEAL_SIZE') {
      return formatCurrency(value);
    }

    //This on is an array of strings with numbers
    if (type === 'LEGAL_STRUCTURE') {
      const LEGAL_STRUCTURE_MAP: { [key: string]: string } = {};
      Object.keys(LEGAL_STRUCTURE).forEach(key => {
        const value = LEGAL_STRUCTURE[key as keyof typeof LEGAL_STRUCTURE];
        LEGAL_STRUCTURE_MAP[value] = key;
      });
      if (type === 'LEGAL_STRUCTURE') {
        if (typeof value === 'string') {
          return value
            .split(',')
            .map((v: any) => capitalize(LEGAL_STRUCTURE_MAP[v]))
            .join(', ');
        } else {
          return value.map((v: any) => LEGAL_STRUCTURE_MAP[v]);
        }
      }
    }

    if (type === 'FINANCING_TYPE') {
      return FINANCING_TYPE[value as keyof typeof FINANCING_TYPE];
    }
  } catch (error) {
    console.log(error);
  }

  return value.toString();
};

export const FormattedText: React.FC<{ condition: any; vendorProfiles?: { [key: string]: string } }> = ({
  condition,
  vendorProfiles = {},
}) => {
  const isDealersFact = condition.fact === 'DEALERS';

  try {
    const fact = friendlyFactName(condition.fact);

    // Special handling for DEALERS fact BEFORE converting values to strings
    if (isDealersFact) {
      const dealerIds = Array.isArray(condition.value) ? condition.value : [];
      const currentDealerId = condition.factResult ? String(condition.factResult) : '';

      console.log('DEALERS fact processing:', { dealerIds, currentDealerId, vendorProfiles });
      console.log(vendorProfiles);
      const allowedDealerNames = dealerIds
        .map((id: string) => {
          console.log(id);
          console.log(_.get(vendorProfiles, id));
          return vendorProfiles[id] || id;
        })
        .join(', ');
      const currentDealerName = vendorProfiles[currentDealerId] || currentDealerId;

      return condition.result ? (
        <>
          <u>{fact}</u> allowed list: <b>{allowedDealerNames}</b> (evaluated: <b>{currentDealerName}</b>)
        </>
      ) : (
        <>
          <u>{fact}</u> criteria not met. Expected one of <b>{allowedDealerNames}</b>, but got{' '}
          <b>{currentDealerName}</b>
        </>
      );
    }

    // For non-DEALERS facts, format values normally
    let factResult = 'N/A';
    if (condition.factResult) {
      factResult = formatValue(condition.fact, condition.factResult.toString());
      console.log(condition);
    }
    const value = formatValue(condition.fact, condition.value.toString());

    switch (condition.operator) {
      case 'greaterThanInclusive':
        return condition.result ? (
          <>
            <u>{fact}</u> is at least <b>{value}</b> (actual: <b>{factResult}</b>)
          </>
        ) : (
          <>
            Expected <u>{fact}</u> to be at least <b>{value}</b>, but it was <b>{factResult}</b>
          </>
        );
      case 'lessThanInclusive':
        return condition.result ? (
          <>
            <u>{fact}</u> is at most <b>{value}</b> (actual: <b>{factResult}</b>)
          </>
        ) : (
          <>
            Expected <u>{fact}</u> to be at most <b>{value}</b>, but it was <b>{factResult}</b>
          </>
        );
      case 'equal':
        return condition.result ? (
          <>
            <u>{fact}</u> is <b>{value}</b>
          </>
        ) : (
          <>
            Is not <b>{fact}</b>
          </>
        );
      case 'in':
        return condition.result ? (
          <>
            <u>{fact}</u> is included on <b>{value}</b>
          </>
        ) : (
          <>
            <u>{fact}</u> criteria not met, expected <b>{value}</b>, but received <b>{factResult}</b>
          </>
        );
      default:
        return (
          <>
            <u>{fact}</u> <b>{factResult}</b> {condition.result ? 'meets' : 'does not meet'} the condition{' '}
            <i>{condition.operator}</i> [<b>{value}</b>]
          </>
        );
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};
